import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SharedModule } from '../../shared/shared.module';
import { SearchDropdownContainerComponent } from './components/search-dropdown-container/search-dropdown-container.component';
import { ConfirmationMessageModalComponent } from './components/confirmation-message-modal/confirmation-message-modal.component';
import { UserViewsModule } from '../../shared/sub-modules/user-views/user-views.module';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    TypeaheadModule,
    SharedModule,
    NgSelectModule,
    SharedModule,
    UserViewsModule,
  ],
  declarations: [
    SearchDropdownContainerComponent,
    ConfirmationMessageModalComponent,
  ],
  exports: [
    SearchDropdownContainerComponent,
    ConfirmationMessageModalComponent,
  ],
  bootstrap: [SearchDropdownContainerComponent],
})
export class PickupsModule {}
